import React from "react";
import { Button, Modal } from "antd"

export const DeleteDiscountModal = ({
   deleteDiscountData = {},
   isModalOpen = false,
   handleSubmit = () => { },
   handleCloseModal = () => { }
}) => {
   return (
      <Modal
         visible={isModalOpen}
         closable={true}
         title={"Delete Discount"}
         onCancel={() => handleCloseModal(false)}
         footer={[
            <Button
               className={'ml-2'}
               key="back"
               label={"Close"}
               onClick={() => handleCloseModal(false)}
            >
               Close
            </Button>,
            <Button
               className={'ml-2'}
               key="submit"
               type="primary"
               // loading={isLoading}
               onClick={() => handleSubmit(deleteDiscountData.id)}
            >
               Submit
            </Button>
         ]}
      >
         <div>
            <p>Are you sure you want to delete <b>"{deleteDiscountData.title}"</b> discount ?</p>
         </div>
      </Modal >
   )
}